import currentVersionJson from '../../public/version.json'
export const appVersion = currentVersionJson.version

